// 換頁帶上下文一律放網址（P0-6、SPEC #vms-web-459 / #vms-web-540）：重新整理、開新分頁、分享連結都還在。
//   回放：/playback?cam=<home>/<aid>&t=<unix 秒>
//   匯出：/exports?new=1&cam=<home>/<aid>&from=<unix 秒>&len=<秒>
// 目的頁先讀網址、再讀舊的 router state（相容還沒改的入口）。

//   可再帶 src=cloud|local|backup（指定來源）、回放的 from=<事件 id>（標出從哪個事件來，回放頁顯示「從事件：…」膠囊）
export type SrcParam = 'cloud' | 'local' | 'backup';

export function playbackHref(cam: string, at?: number | null, opts: { src?: SrcParam; event?: string; lens?: number; recTarget?: 'sd' } = {}): string {
  const q = new URLSearchParams({ cam });
  if (typeof at === 'number' && Number.isFinite(at)) q.set('t', String(Math.floor(at)));
  if (opts.src) q.set('src', opts.src);
  if (opts.event) q.set('from', opts.event);
  if (opts.recTarget) q.set('rec_target', opts.recTarget);
  if (opts.lens) q.set('lens', String(opts.lens)); // 多鏡頭：回放哪顆鏡頭（0 不帶）
  return '/playback?' + q;
}

export function exportHref(cam: string, from?: number | null, len = 600, src?: SrcParam, reason?: string): string {
  const q = new URLSearchParams({ new: '1', cam });
  if (typeof from === 'number' && Number.isFinite(from)) {
    q.set('from', String(Math.floor(from)));
    q.set('len', String(Math.round(len)));
  }
  if (src) q.set('src', src);
  if (reason) q.set('reason', reason);
  return '/exports?' + q;
}

/** 網址的 unix 秒（不是數字 = undefined）。 */
export function numParam(sp: URLSearchParams, k: string): number | undefined {
  const v = sp.get(k);
  if (v === null || v === '') return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
}
